import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import Link from 'web-app/react/components/link/link';
import { InnerContent } from './inner-content';
const StyledChildPreview = styled.li `
    display: flex;
    align-items: center;
    img {
        height: 35px;
        width: 35px;
        border-radius: 50%;
        margin-right: 8px;
    }
    & + & {
        margin-top: 8px;
    }
`;
const HoverStyle = css `
    display: flex;
    align-items: center;
    margin: 0 -10px;
    padding: 0 10px;
    width: 100%;
    color: inherit;
    &:hover {
        background-color: rgba(255, 255, 255, 0.1);
    }
`;
const StyledLink = styled(Link) `
    ${HoverStyle}
`;
const StyledHover = styled.div `
    cursor: pointer;
    ${HoverStyle}
`;
export const ProfileImageTooltip = ({ item, emptyImageSrc }) => {
    let content;
    if ('link' in item && item.link) {
        content = (_jsx(StyledLink, { href: item.link, onClick: e => e.stopPropagation(), children: _jsx(InnerContent, { item: item, emptyImageSrc: emptyImageSrc }) }));
    }
    else if ('onClick' in item && item.onClick) {
        content = (_jsx(StyledHover, { onClick: item.onClick, children: _jsx(InnerContent, { item: item, emptyImageSrc: emptyImageSrc }) }));
    }
    else {
        content = _jsx(InnerContent, { item: item, emptyImageSrc: emptyImageSrc });
    }
    return (_jsx(StyledChildPreview, { onClick: 'onClick' in item && item.onClick ? item.onClick : undefined, children: content }));
};
